/**
 * @fileoverview Individual colored tag item component
 * @active CONFIRMED - This component is actively used in the application
 * 
 * This component renders a single colored tag item with consistent styling.
 * It handles click events for filtering when a tag is clicked.
 * 
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/shared/coloredTags/index.tsx} - Parent tags container
 * @see {@link src/components/companies/companiesList/newCompaniesList/companiesTable/companyInfoTable/CompaniesInfoTableRow.tsx} - Table row component
 * @see {@link src/components/companies/companiesList/companiesListComponents/tableMain/TableElements.jsx} - Legacy implementation (deprecated)
 */

// src/components/companies/companiesList/newCompaniesList/companiesTable/shared/coloredTags/ColoredItem.tsx

import { memo } from "react";

import { Flex, Text } from "@chakra-ui/react";

interface ColoredItemProps {
  item: {
    name?: string;
    color?: string;
    isCurrent?: boolean;
  };
  handler?: (params: { key: string; item: any }) => void;
  filterKey?: string;
}

const ColoredItem = ({ item, handler, filterKey }: ColoredItemProps) => {
  if (!item?.name || !item?.color) return null;
  
  return (
    <Flex
      align={"center"}
      justify={"center"}
      p={"4px"}
      borderRadius={"4px"}
      bg={item.color}
      cursor={filterKey ? "pointer" : "default"}
      onClick={() => handler && filterKey && handler({ key: filterKey, item })}
    >
      <Text
        mt={"4px"}
        fontSize={"14px"}
        fontWeight={"400"}
        lineHeight={"1"}
        letterSpacing={"2%"}
      >
        {item.name}
      </Text>
    </Flex>
  );
};

export default memo(ColoredItem);
